import { render, staticRenderFns } from "./editActual.vue?vue&type=template&id=4987e036&scoped=true"
import script from "./editActual.vue?vue&type=script&lang=js"
export * from "./editActual.vue?vue&type=script&lang=js"
import style0 from "./editActual.vue?vue&type=style&index=0&id=4987e036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4987e036",
  null
  
)

export default component.exports